module.exports = __webpack_public_path__ + "images/media/logos/vitality-logo.f48acfd3c3a0c9d361ebe34e5b93a980.svg";